// extracted by mini-css-extract-plugin
export default {"SmallLink":"Lenses_SmallLink__FNIz3"};